









































import { defineComponent } from '@vue/composition-api';

const BomBudgetInput = defineComponent({
  props: {
    value: {
      default: () => ({
        category: '', name: '', cost: 0, lock: false,
      }),
    },
    editable: { default: true },
  },
  setup(props, { emit }) {
    function updateBudgetName($event: any) {
      emit('input', { ...props.value, name: $event.target.value, cost: props.value.cost });
    }
    function updateBudgetValue(value: any) {
      emit('input', { ...props.value, name: props.value.name, cost: value });
    }
    function updateLockValue(value: any) {
      emit('input', { ...props.value, lock: value });
    }

    return {
      updateBudgetName,
      updateBudgetValue,
      updateLockValue,
    };
  },
});

export default BomBudgetInput;
